// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a64ee53b","845":"f6fd0787"}[chunkId] + ".chunk.js";
};